import * as _ from 'lodash';
import { AudioManager } from '../utilities/AudioManager';

export class MultiplierBoard extends Phaser.GameObjects.Container {
  private multiplier: number = 0;

  private multiplierBalls: Phaser.GameObjects.Image[] = [];
  private winningNumberBalls: Phaser.GameObjects.Image[] = [];
  private screenWidth: any;
  private screenHeight: any;
  drawResult: any;
  private availableMultipliers: number[];
  winningNumbers: any;
  private paused: boolean = false;

  private shadow: any;

  constructor(scene, screenWidth, screenHeight, multiplier, drawResult) {
    super(scene);
    this.scene = scene;
    this.screenWidth = screenWidth;
    this.screenHeight = screenHeight;
    this.drawResult = drawResult;

    this.multiplier = multiplier;

    this.availableMultipliers = _.shuffle([1, 2, 3, 4, 5].filter(x => x !== this.multiplier));
    this.availableMultipliers.push(this.multiplier);

    if (this.drawResult && this.drawResult.length > 0) {
      this.winningNumbers = this.drawResult.slice(0, 5);
    }
    this.showMultipliers();
  }

  private showMultipliers() {
    const positionY = this.screenHeight / 1.8;
    const size = 160;
    const rowMarginHorizontal = 115;
    const ballLeftMargin = 130;

    this.shadow = this.scene.add.sprite(this.screenWidth / 2.2, this.screenHeight / 1.44, 'multiplier_shadow');

    let ballPositionX = rowMarginHorizontal;
    for (let i = 0; i < 5; i++) {
      const multiplier = i + 1;
      const ballKey = `${multiplier}-multiplier`;

      ballPositionX = i > 0 ? ballPositionX + ballLeftMargin : ballPositionX;

      const ball = this.scene.add.sprite(ballPositionX, positionY, ballKey).setDisplaySize(size, size);
      ball.setScale(0);
      ball.setAlpha(0);
      // ball.setOrigin(0.5);
      this.multiplierBalls.push(ball);

      this.scene.tweens.add({
        targets: ball,
        props: { scale: 1, alpha: 1 },
        ease: 'Power2',
        duration: 200,
        repeat: 0,
        yoyo: false
      });
    }

    this.blinkMultiplier();
  }

  pauseTimer() {
    if (!this.paused) {
      AudioManager.getInstance().pauseSoundEffect(this.scene);
      this.scene.tweens.pauseAll();
      this.scene.time.paused = true;
      this.paused = true;
    }
  }

  resumeTimer() {
    if (this.paused) {
      AudioManager.getInstance().resumeSoundEffect(this.scene);
      this.scene.tweens.resumeAll();
      this.scene.time.paused = false;
      this.paused = false;
    }
  }

  private blinkMultiplier() {
    const availableMultipliers: number[] = _.shuffle([1, 2, 3, 4, 5].filter(x => x !== this.multiplier));
    availableMultipliers.push(this.multiplier);
    for (let i = 0; i < availableMultipliers.length; i++) {
      if (!this.scene.time.paused) {
        const ball = this.multiplierBalls[availableMultipliers[i] - 1];
        this.scene.time.delayedCall(500 * (i + 1), isLast => this.switchYellowMultiplier(ball, availableMultipliers[i], isLast), [
          i === availableMultipliers.length - 1
        ]);
      }
    }
  }

  private switchYellowMultiplier(ball: Phaser.GameObjects.Image, multiplier: number, isLast: boolean) {
    if (!this.scene.time.paused) {
      ball.setTexture(`${multiplier}-multiplier-highlight`);
      this.scene.time.delayedCall(250, () => this.switchWhiteMultiplier(ball, multiplier, isLast), [], this);
    }
  }

  private switchWhiteMultiplier(ball: Phaser.GameObjects.Image, multiplier: number, isLast: boolean) {
    if (isLast) {
      this.shadow.setVisible(false);
      this.finalAnimations(ball);
    } else {
      ball.setTexture(`${multiplier}-multiplier`);
    }
  }

  private finalAnimations(multiplierBall: Phaser.GameObjects.Image) {
    const scaleUpMultiplierAnimation = this.scene.tweens.createTimeline();

    const filteredMultiplierBalls = this.multiplierBalls.filter(m => m !== multiplierBall);
    for (let i = 0; i < filteredMultiplierBalls.length; i++) {
      const ball = filteredMultiplierBalls[i];
      this.scene.tweens.add({
        targets: ball,
        props: { scale: 0, alpha: 0 },
        ease: 'Power2',
        duration: 1000,
        repeat: 0,
        yoyo: false
      });
    }

    scaleUpMultiplierAnimation.add({
      targets: multiplierBall,
      props: { scale: 2.3, x: this.screenWidth / 2, y: this.screenHeight / 2 + 100 },
      ease: 'Power2',
      duration: 700,
      repeat: 0,
      yoyo: false
    });

    scaleUpMultiplierAnimation.add({
      targets: multiplierBall,
      props: { scale: 2.8 },
      ease: 'Power2',
      duration: 200,
      repeat: 0,
      yoyo: true
    });

    scaleUpMultiplierAnimation.add({
      targets: multiplierBall,
      props: { scale: 1.1, x: this.screenWidth / 2, y: this.screenHeight / 2 + 370 },
      ease: 'Power2',
      duration: 500,
      delay: 1000,
      repeat: 0,
      yoyo: false,
      onComplete: () => this.showFinalAnimation()
    });
    scaleUpMultiplierAnimation.play();
  }

  private showFinalAnimation() {
    const positionY = this.screenHeight / 1.9;
    const size = 120;
    const rowMarginHorizontal = 115;
    const ballLeftMargin = 130;
    AudioManager.getInstance().playSoundEffect(this.scene, 'Bright_Bonus_Win');
    const winningNumberText = this.scene.add.image(this.screenWidth / 2, this.screenHeight / 2 - 80, 'winning_numbers').setAlpha(0);
    let ballPositionX = rowMarginHorizontal;
    let ballPositionY = positionY;
    for (let i = 0; i < 5; i++) {
      ballPositionX = i > 0 ? ballPositionX + ballLeftMargin : ballPositionX;
      ballPositionY = (i + 1) % 2 === 0 ? this.screenHeight / 1.75 : positionY;
      this.scene.add.sprite(ballPositionX, ballPositionY, 'dice' + this.winningNumbers[i]).setDisplaySize(size, size);
    }

    this.scene.tweens.add({
      targets: winningNumberText,
      props: { scale: 1, alpha: 1 },
      ease: 'Power2',
      duration: 250,
      repeat: 0,
      yoyo: false
    });

    for (let i = 0; i < this.winningNumberBalls.length; i++) {
      const ball = this.winningNumberBalls[i];
      this.scene.tweens.add({
        targets: ball,
        props: { scale: 1, alpha: 1, y: ball.y + 45 },
        ease: 'Power2',
        duration: 250,
        repeat: 0,
        yoyo: false
      });
    }

    const bonusMultiplierText = this.scene.add.image(this.screenWidth / 2, this.screenHeight / 2 + 240, 'super_bonus').setAlpha(0);
    this.scene.tweens.add({
      targets: bonusMultiplierText,
      props: { scale: 1, alpha: 1 },
      ease: 'Power2',
      duration: 250,
      repeat: 0,
      yoyo: false
    });
    this.scene.events.emit('multiplierNumberAnimationEnded');
  }
}
